// import { Button, ButtonProps } from "@mui/material";
// import React, { useState } from "react";
// import HelpVideoModal from "./modal/HelpVideoModal";

// type HelpVideoButtonProps = Omit<ButtonProps, "onClick"> & {
//   youtubeUrl: string;
//   modalTitle?: string;
//   startSeconds?: number;
// };

// const HelpVideoButton: React.FC<HelpVideoButtonProps> = ({
//   youtubeUrl,
//   modalTitle = "Ajuda em Vídeo",
//   startSeconds,
//   children,
//   ...btnProps
// }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <Button
//         variant="outlined"
//         // startIcon={<HelpOutlineIcon />}
//         onClick={() => setOpen(true)}
//         {...btnProps}
//       >
//         {children ?? "Tutorial"}
//       </Button>

//       <HelpVideoModal
//         open={open}
//         onClose={() => setOpen(false)}
//         youtubeUrl={youtubeUrl}
//         title={modalTitle}
//         startSeconds={startSeconds}
//       />
//     </>
//   );
// };

// export default HelpVideoButton;

// Arquivo: src/components/HelpVideoButton.tsx
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import React, { useState } from "react";
import HelpVideoModal from "./modal/HelpVideoModal";

type HelpVideoButtonProps = Omit<IconButtonProps, "onClick"> & {
  youtubeUrl: string;
  modalTitle?: string;
  startSeconds?: number;
  titleTooltip?: string;
};

const HelpVideoButton: React.FC<HelpVideoButtonProps> = ({
  youtubeUrl,
  modalTitle = "Ajuda em Vídeo",
  startSeconds,
  titleTooltip = "Ajuda em Vídeo",
  ...iconProps
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={titleTooltip}>
        <IconButton
          aria-label="Abrir ajuda em vídeo"
          size="small"
          onClick={() => setOpen(true)}
          {...iconProps}
        >
          <HelpOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <HelpVideoModal
        open={open}
        onClose={() => setOpen(false)}
        youtubeUrl={youtubeUrl}
        title={modalTitle}
        startSeconds={startSeconds}
      />
    </>
  );
};

export default HelpVideoButton;
